module.exports = __webpack_public_path__ + "static/media/corporate-services-img87.ac457ffa.jpg";